<template>
  <b-row no-gutters id="change-mobile-container">
    <b-col md="1">
      <img
        src="@/assets/images/ic-arrow-left.svg"
        width="30"
        class="arrow mb-2"
        alt
        @click="changeComponent('Details')"
      />
    </b-col>
    <b-col md="11">
      <h2 class="header-title">Change Mobile Number</h2>
      <div class="component-container mt-30">
        <component
          :is="currentComponent"
          @change-component="changeThisComponent"
          :webDesign="webDesign"
          @set-customer-update-mobile="setCustomerUpdateMobileNumber"
          :customerUpdateMobileNumber="customerUpdateMobileNumber"
          @set-change-mobile-modal-message="setChangeMobileNumberModalMessage"
          :customer="customer">
        </component>
      </div>
    </b-col>
    <ChangeMobileNumberGenericModal
      :modal-message="changeMobileModalMessage"
      :webDesign="webDesign"
      @change-component="changeComponent"
      :success="isSuccess" />
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import AccountVerify from './AccountVerify';
import NewMobileNumber from './NewMobileNumber';
import ChangeMobileOTP from './ChangeMobileOTP';
import ChangeMobileNumberGenericModal from './ChangeMobileNumberGenericModal';

export default {
  name: 'EditProfileMobileNumber',
  components: {
    AccountVerify, NewMobileNumber, ChangeMobileOTP, ChangeMobileNumberGenericModal
  },
  data() {
    return {
      currentComponent: 'AccountVerify',
      customerUpdateMobileNumber: null,
      changeMobileModalMessage: null,
      isSuccess: false
    }
  },
  computed: {
    ...mapState("estore", {
      webDesign: (state) => state.webDesign
    }),
    ...mapState("customer", {
      customer: (state) => state.user
    })
  },
  methods: {
    changeThisComponent(component) {
      this.currentComponent = component;
    },
    changeComponent(component) {
      this.$emit("change-component", component);
    },
    setCustomerUpdateMobileNumber(data) {
      this.customerUpdateMobileNumber = data;
    },
    setChangeMobileNumberModalMessage(message, success = false) {
      this.isSuccess = success;
      this.changeMobileModalMessage = message;
    }
  }
}
</script>
